import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import autoTable from "jspdf-autotable";


const ProposalInwardList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const {
    GetProposalInwardsList,
    ProposalApprovalOperation,
    CreateToken,
    Usermenu,
  } = context;

  const nav = useNavigate();
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  //  const [technicalInwards, setTechnicalInwards] = useState([])
  const [SelectedOptions, setSelectedOptions] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("All District");
  const [selectedTaluka, setSelectedTaluka] = useState("All Taluka");
  const [currentPage, setCurrentPage] = useState(() => {
    const page = searchParams.get("page");
    return page ? parseInt(page) : 1;
  });
  const [exportingPDF, setExportingPDF] = useState(false);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;

  const sortedBills = filteredBills;
  // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const sortedBills = Array.isArray(filteredBills)
  //   ? filteredBills
  //       .slice() // ✅ prevent state mutation
  //       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
  //   : [];
  const currentBills = sortedBills.slice(indexOfFirstBill, indexOfLastBill);

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);
  const [selectedWorkNames, setSelectedWorkNames] = useState([]);
  const [SelectedProposalDetail, setSelectedProposalDetail] = useState([]);
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const [adminData, setAdminData] = useState([]);

  const GetAdminData = async () => {
    try {
      let data = await Usermenu();
      console.log("data ------------", data);

      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return [];
      }

      const userData = data.Data; // ← Access Data object
      const menuList = data.result || []; // ← Access menu list

      setAdminData(userData);

      console.log("User Data:", userData);
      console.log("Menus:", menuList);
    } catch (err) {
      console.error("Error in GetAdminData:", err);
    }
  };
  useEffect(() => {
    GetAdminData();
  }, []);
  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("Proposal Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }

  const getTechnicalInwardsList = async () => {
    let data = (await GetProposalInwardsList("All", "All")) || [];
    console.log("data------------", data);
    setTechnicalInwards(data);
    setFilteredBills(data);
  };

  useEffect(() => {
    getTechnicalInwardsList();
  }, []);

  let inwardList = [];
  if (technicalInwards && technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    // setCurrentPage(1);
  }, [searchTerm, technicalInwards]);

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;
    if (totalPages > 0 && page > totalPages) {
      setCurrentPage(totalPages);
      setSearchParams({ page: totalPages });
    } else if (page < 1) {
      setCurrentPage(1);
      setSearchParams({ page: 1 });
    }
  }, [searchParams, totalPages, setSearchParams]);

  // useEffect(() => {
  //     if (technicalInwards) {
  //         let res = technicalInwards.filter((item) => item.Status == SelectedOptions );
  //         setFilteredBills(res);
  //     }
  // }, [SelectedOptions, technicalInwards])
  useEffect(() => {
    if (!technicalInwards) return;

    let res = technicalInwards;
   if (SelectedOptions === "") {
  const uniqueMap = new Map();
  technicalInwards.forEach((item) => {
    uniqueMap.set(item.workuniqueid, item);
  });
  res = Array.from(uniqueMap.values());
} else {
  res = technicalInwards.filter((item) => item.Status === SelectedOptions);
}

    if (selectedDistrict !== "All District") {
      res = res.filter((item) => item.District === selectedDistrict);
    }
    // Taluka Filter
    if (selectedTaluka !== "All Taluka") {
      res = res.filter(
        item => item.Taluka === selectedTaluka
      );
    }

    setFilteredBills(res);
  }, [SelectedOptions, technicalInwards, selectedDistrict, selectedTaluka]);

  useEffect(() => {
    if (selectedBills.length > 0) {
      const selectedDetails = technicalInwards.filter((item) =>
        selectedBills.includes(item.ProposalID),
      );
      setSelectedProposalDetail(selectedDetails);
    } else {
      setSelectedProposalDetail([]);
    }
  }, [selectedBills, technicalInwards]);

  const handleCheckboxChange = (proposalId, workName) => {
    if (selectedBills.includes(proposalId)) {
      setSelectedBills(selectedBills.filter((id) => id !== proposalId));
      setSelectedWorkNames(
        selectedWorkNames.filter((name) => name !== workName),
      );
    } else {
      setSelectedBills([...selectedBills, proposalId]);
      setSelectedWorkNames([...selectedWorkNames, workName]);
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.ProposalID));
      setSelectedWorkNames(currentBills.map((bill) => bill.Work_name));
    } else {
      setSelectedBills([]);
      setSelectedWorkNames([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Proposal selected for approval!");
      return;
    }
    setLoading(true);
    if (condition == "Rejected") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      // ❌ If remark is empty after trimming
      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }
    try {
      let response = await ProposalApprovalOperation(
        selectedBills,
        condition,
        remark,
        Etoken,
        selectedWorkNames,
        SelectedProposalDetail,
      ); // Call backend function
      if (response.message) {
        alert(response.message);
        // window.location.reload()
        setRemark("");
        setRejectpanelhide(false);
        getTechnicalInwardsList(); // Refresh the list after approval
      }
      if (response.error) {
        console.log("response error", response.error);
        alert(response.error);
        // window.location.reload()
        getTechnicalInwardsList(); // Refresh the list after approval
      }
    } catch (error) {
      console.error("Error approving Proposal:", error);
      alert("An error occurred while approving bills.");
    }
    setLoading(false); // Stop loader
  };

  const districtList = [
    ...new Set(technicalInwards?.map((item) => item.District).filter(Boolean)),
  ];

  const exportPendingProposalsToExcel = async (
    bills,
    filename = "Proposal_Approval_Pending.xlsx"
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }

    setLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 500));

    try {
      const excelData = bills.map((proposal, index) => ({
        "Sr.No.": index + 1,
        // "Proposal Name": proposal.Work_name || "",
        "Proposal File Number": proposal.Proposal_fileNumber || "",
        "HeadCode": proposal.HeadCode || "",
        "Proposal Year": proposal.Proposal_year || "",
        "District": proposal.District || "",
        // "Gram Panchayat": proposal.Gram_panchayat || "",
        "Total Proposal Amount": Number(
          proposal.Proposal_amount || 0
        ),
        // "Remark": proposal.Remark || "",
        // "Status": proposal.Status || "",
      }));

      // Total Row
      const totalRow = {
        "Sr.No.": "",
        // "Proposal Name": "",
        "Proposal File Number": "",
        "HeadCode": "",
        "Proposal Year": "",
        "District": "Total",
        // "Gram Panchayat": "Total",
        "Total Proposal Amount": bills.reduce(
          (sum, item) =>
            sum + Number(item.Proposal_amount || 0),
          0
        ),
        // "Remark": "",
        // "Status": "",
      };


      excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Column widths
      worksheet["!cols"] = [
        { wch: 10 }, // Sr.No.
        { wch: 25 }, // Proposal File Number
        { wch: 35 }, // HeadCode
        { wch: 12 }, // Year
        { wch: 25 }, // District
        { wch: 25 }, // Total Proposal Amount
      ];

      // Freeze header
      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };

      // Filter
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 1,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Pending Proposals"
      );

      XLSX.writeFile(workbook, filename);

    } catch (error) {
      console.error(
        "Pending Proposal Excel Export Error:",
        error
      );
      alert("Error while downloading Excel");
    } finally {
      setLoading(false);
    }
  };


  const exportSendBackProposalsToExcel = async (
    bills,
    filename = "Proposal_Approval_SendBack.xlsx"
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }

    setLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 500));

    try {
      const excelData = bills.map((proposal, index) => ({
        "Sr.No.": index + 1,
        "Proposal Name": proposal.Work_name || "",
        "Proposal File Number": proposal.Proposal_fileNumber || "",
        "Proposal Year": proposal.Proposal_year || "",
        "HeadCode": proposal.HeadCode || "",
        "District": proposal.District || "",
        "Gram Panchayat": proposal.Gram_panchayat || "",
        "Total Proposal Amount": Number(
          proposal.Proposal_amount || 0
        ),
        "Remark": proposal.Remark || "",
        "Status": proposal.Status || "",
      }));

      // Total Row
      const totalRow = {
        "Sr.No.": "Total",
        "Proposal Name": "",
        "Proposal File Number": "",
        "Proposal Year": "",
        "HeadCode": "",
        "District": "",
        "Gram Panchayat": "",
        "Total Proposal Amount": bills.reduce(
          (sum, item) =>
            sum + Number(item.Proposal_amount || 0),
          0
        ),
        "Remark": "",
        "Status": "",
      };

      excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Column widths
      worksheet["!cols"] = [
        { wch: 10 }, // Sr.No.
        { wch: 40 }, // Proposal Name
        { wch: 35 }, // HeadCode
        { wch: 15 }, // Proposal Year
        { wch: 25 }, // District
        { wch: 25 }, // Gram Panchayat
        { wch: 25 }, // Proposal Amount
        { wch: 40 }, // Remark
        { wch: 25 }, // Status
      ];

      // Freeze header
      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };

      // Filter
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 1,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Send Back Proposals"
      );

      XLSX.writeFile(workbook, filename);

    } catch (error) {
      console.error(
        "Send Back Proposal Excel Export Error:",
        error
      );
      alert("Error while downloading Excel");
    } finally {
      setLoading(false);
    }
  };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   try {
  //     setExportingPDF(true);

  //     // Wait for React re-render
  //     await new Promise((resolve) => setTimeout(resolve, 1000));

  //     const tableElement = document.querySelector(`.${tableClass}`);
  //     // const tableElement = document.getElementById("proposalTable");

  //     if (!tableElement) {
  //       alert("Table not found");
  //       return;
  //     }

  //     const pdf = new jsPDF("l", "mm", "a4");

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     pdf.setFontSize(18);
  //     pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //     const canvas = await html2canvas(tableElement, {
  //       scale: 2,
  //       useCORS: true,
  //       allowTaint: true,
  //       logging: false,
  //       backgroundColor: "#ffffff",
  //       scrollX: 0,
  //       scrollY: -window.scrollY,
  //       windowWidth: tableElement.scrollWidth,
  //       windowHeight: tableElement.scrollHeight,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const imgWidth = pageWidth - 20;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     let heightLeft = imgHeight;
  //     let position = 25;

  //     pdf.addImage(
  //       imgData,
  //       "PNG",
  //       10,
  //       position,
  //       imgWidth,
  //       imgHeight
  //     );

  //     heightLeft -= (pageHeight - 25);

  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight + 25;

  //       pdf.addPage();

  //       pdf.addImage(
  //         imgData,
  //         "PNG",
  //         10,
  //         position,
  //         imgWidth,
  //         imgHeight
  //       );

  //       heightLeft -= pageHeight;
  //     }

  //     pdf.save(filename);
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //   }
  // };

      const downloadTableOnlyAsPDF = async (
          tableClass,
          filename,
          title,
          chunkSize = 500, // 🔥 300–500 recommended
      ) => {
          const originalTable = document.querySelector(`.${tableClass}`);
          if (!originalTable) {
              setExportingPDF(false);
              return;
          }
  
          setLoading(true);
          setExportingPDF(true);
  
          // Allow loader to render first
          await new Promise((resolve) => setTimeout(resolve, 600));
  
          try {
              const originalRows = originalTable.querySelectorAll("tbody tr");
              const totalRows = originalRows.length;
  
              if (!totalRows) {
                  setLoading(false);
                  setExportingPDF(false);
                  return;
              }
  
              for (let start = 0; start < totalRows; start += chunkSize) {
                  const end = Math.min(start + chunkSize, totalRows);
  
                  // 🔥 Clone table cleanly
                  const tableClone = originalTable.cloneNode(true);
                  const rows = tableClone.querySelectorAll("tbody tr");
  
                  // Remove rows outside current chunk
                  rows.forEach((row, index) => {
                      if (index < start || index >= end) {
                          row.remove();
                      }
                  });
  
                  // Hide cloned table from view
                  tableClone.style.position = "absolute";
                  tableClone.style.left = "-9999px";
                  tableClone.style.top = "0";
                  document.body.appendChild(tableClone);
  
                  const pdf = new jsPDF("p", "mm", "a4");
                  const pageWidth = pdf.internal.pageSize.getWidth();
                  const pageHeight = pdf.internal.pageSize.getHeight();
  
                  const topMargin = 25;
                  const sideMargin = 10;
                  const bottomMargin = 15;
  
                  pdf.setFontSize(16);
                  pdf.setFont("helvetica", "bold");
                  pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
                      align: "center",
                  });
  
                  const canvas = await html2canvas(tableClone, {
                      scale: 1,
                      useCORS: true,
                      backgroundColor: "#2C78DB",
                  });
  
                  const imgWidth = pageWidth - sideMargin * 2;
                  const pxToMm = imgWidth / canvas.width;
  
                  const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
                  const usablePageHeightPx = usablePageHeightMm / pxToMm;
  
                  let renderedHeight = 0;
                  let pageNumber = 0;
  
                  while (renderedHeight < canvas.height) {
                      const sliceHeight = Math.min(
                          usablePageHeightPx,
                          canvas.height - renderedHeight,
                      );
  
                      const pageCanvas = document.createElement("canvas");
                      const context = pageCanvas.getContext("2d");
  
                      pageCanvas.width = canvas.width;
                      pageCanvas.height = sliceHeight;
  
                      context.drawImage(
                          canvas,
                          0,
                          renderedHeight,
                          canvas.width,
                          sliceHeight,
                          0,
                          0,
                          canvas.width,
                          sliceHeight,
                      );
  
                      const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);
  
                      if (pageNumber > 0) pdf.addPage();
  
                      pdf.addImage(
                          imgData,
                          "JPEG",
                          sideMargin,
                          topMargin,
                          imgWidth,
                          sliceHeight * pxToMm,
                      );
  
                      renderedHeight += sliceHeight;
                      pageNumber++;
                  }
  
                  pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
  
                  document.body.removeChild(tableClone);
  
                  // Small delay prevents UI freezing
                  await new Promise((resolve) => setTimeout(resolve, 300));
              }
          } catch (error) {
              console.error("PDF Export Error:", error);
          } finally {
              setExportingPDF(false);
              setLoading(false);
          }
      };
  
      
  const handleExportExcel = () => {
    const excelData = filteredBills.map((item, index) => ({
      "Sr.No.": index + 1,
      "Proposal File Number": item.Proposal_fileNumber,
      "HeadCode": item.HeadCode,
      "Year": item.Proposal_year,
      "District": item.District,
      "Taluka": item.Taluka,
      "Total Proposal Amount":
        item.TotalProposalAmount || item.Proposal_amount || 0,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 25 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 }
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Proposal Approval"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      }
    );

    saveAs(
      data,
      `Proposal_Approval_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };


  const talukaList = [
    ...new Set(
      technicalInwards
        ?.map(item => item.Taluka)
        .filter(Boolean)
    )
  ];

  // Page Total
  const pageTotalProposalAmount = currentBills.reduce(
    (sum, item) => sum + Number(item.TotalProposalAmount || item.Proposal_amount || 0),
    0
  );

  // Gross Total
  const grossTotalProposalAmount = filteredBills.reduce(
    (sum, item) => sum + Number(item.TotalProposalAmount || item.Proposal_amount || 0),
    0
  );

  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-12 px-3 m-auto">
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
            <h5 className="my-auto fw-bold">
              <img
                src="/GR-Approval64.png"
                alt="Technical Approval"
                style={{ width: "24px", height: "24px" }}
                className="my-auto me-1"
              />
              <span className="my-auto">{t("Proposal Inwards List")}</span>
            </h5>
            <div
              style={{
                position: "relative",
                width: "250px",
                marginRight: "10px",
              }}
            >
              <img
                src="/Search32.png"
                alt="Search Icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder={t("Search Here")}
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 32px", // left padding makes space for icon
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "14px",
                  color: "#333",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  outline: "none",
                }}
              />
            </div>
          </div>
          {/* <div className="d-flex gap-2" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button
                            className="btn btn-success me-4"
                            onClick={handleExportExcel}
                        >
                            {t("Download Excel")}
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() =>
                                downloadTableOnlyAsPDF(
                                    "proposalPdfTable",
                                    "Proposal_Approval_Report.pdf",
                                    "Proposal Approval Report"
                                )
                            }
                        >
                            {t("Download PDF")}
                        </button>
                    </div> */}

          <div className="col-12 my-4">
            <div
              className="col-12 py-4 "
              style={{
                background: "linear-gradient(to right, #c8d0e3, #b7dff5)",
                borderRadius: "10px",
              }}
            >
              <div className="col-12 px-4">
                <div className="row align-items-center">
                  {/* Status Label */}
                  <div
                    className={`${adminData.RoleID === 17 ? "col-2" : "col-2"} text-end`}
                  >
                    <label className="fw-bold">{t("Select Status")}</label>
                  </div>

                  {/* Status Dropdown */}
                  <div
                    className={`${adminData.RoleID === 17 ? "col-4" : "col-4"}`}
                  >
                    <select
                      className="w-100 py-2 px-3"
                      style={{
                        border: "none",
                        borderRadius: "6px",
                        outline: "none",
                        fontSize: "14px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      }}
                      onChange={(e) => setSelectedOptions(e.target.value)}
                    >
                      
                                            <option value="">{t("All")}</option>
                                            <option value="Pending">{t("Approve")}</option>
                      {adminData.Role !== "Additional CEO" && (
                        <option value="SendBack">{t("Send Back")}</option>
                      )}
                    </select>

                  </div>

                  {/* District Filter */}
                  {/* {adminData.RoleID === 17 && (
                    <>
                      <div className="col-2 text-end">
                        <label className="fw-bold">{t("District")}</label>
                      </div>

                      <div className="col-4">
                        <select
                          className="w-100 py-2 px-3"
                          value={selectedDistrict}
                          onChange={(e) => setSelectedDistrict(e.target.value)}
                          style={{
                            border: "none",
                            borderRadius: "6px",
                            outline: "none",
                            fontSize: "14px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          }}
                        >
                          <option value="All District">
                            {t("All District")}
                          </option>

                          {districtList.map((district, index) => (
                            <option key={index} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  )} */}
                  <div className="col-2 text-end">
                    <label className="fw-bold">{t("Taluka")}</label>
                  </div>

                  <div className="col-4">
                    <select
                      className="w-100 py-2 px-3"
                      value={selectedTaluka}
                      onChange={(e) => setSelectedTaluka(e.target.value)}
                      style={{
                        border: "none",
                        borderRadius: "6px",
                        outline: "none",
                        fontSize: "14px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
                      }}
                    >
                      <option value="All Taluka">
                        {t("All Taluka")}
                      </option>

                      {talukaList.map((taluka, index) => (
                        <option key={index} value={taluka}>
                          {taluka}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {SelectedOptions === "Pending" && (
            <div
              className="m-auto"
              style={{
                width: "98%",
                backgroundColor: "white",
                padding: "30px 30px",
                boxShadow: "0px 0px 5px 1px #c7c9cc",
                borderRadius: "20px",
              }}
            > <div
              className="col-12 mb-3"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
              }}
            >
                <button
                  className="btn btn-success"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    padding: "8px 18px",
                    borderRadius: "8px",
                  }}
                  disabled={loading || filteredBills.length === 0}
                  onClick={() =>
                    exportPendingProposalsToExcel(
                      filteredBills,
                      "Proposal_Approval_Pending.xlsx"
                    )
                  }
                >
                  {loading ? "Downloading..." : t("Download Excel")}
                </button>
                <button
                  className="btn btn-danger"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    padding: "8px 18px",
                    borderRadius: "8px",
                  }}
                  disabled={loading || filteredBills.length === 0}
                  onClick={() =>
                    downloadTableOnlyAsPDF(
                      "proposalpending",
                      "Proposal_Approval_Pending.pdf",
                      "Proposal Approval - Pending"
                    )
                  }
                >
                  {loading ? "Downloading..." : t("Download PDF")}
                </button>

              </div>
              <div
                className="col-12 tableDesign"
                style={{
                  background: '#2C78DB', overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "600px", // change height as needed
                  position: "relative",
                }}
              >
                <table
                  className="m-0 p-0 proposalpending"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead style={{ padding: "12px 15px" }}>
                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                      <th style={{ width: "8%", padding: "12px 15px" }}>{t("Sr.No.")}</th>
                      {!exportingPDF && (
                        <th style={{ width: "8%", padding: "12px 15px" }}>{t("View")}</th>
                      )}
                      {/* <th style={{ width: "8%" }}>{t("Sr.No.")}</th>
                      <th style={{ width: "8%" }}>{t("View")}</th>
                      <th style={{ width: "15%" }}>Proposal Work Name</th>
                      <th style={{ width: "10%" }}>
                        {t("Proposal File Number")}
                      </th>
                      <th style={{ width: "20%" }}>{t("HeadCode")}</th>
                      <th style={{ width: "7%" }}>{t("Year")}</th>
                      <th style={{ width: "10%" }}>Scheme Name</th>
                      <th style={{ width: "8%" }}>{t("District")}</th>
                      <th style={headerStyle}>{t("Taluka")}</th>
                      <th style={{ width: "8%" }}>Gram Panchayat</th>
                      <th style={{ width: "14%" }}>
                        {t("Total Proposal Amount")}
                      </th> */}
                      <th style={{ width: "15%", padding: "12px 15px" }}>Proposal Name</th>
                      <th style={{ width: "10%", padding: "12px 15px" }}>{t("Proposal File Number")}</th>
                      <th style={{ width: "7%", padding: "12px 15px" }}>{t("Proposal Year")}</th>
                      <th style={{ width: "20%", padding: "12px 15px" }}>{t("HeadCode")}</th>
                      {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
                      <th style={{ width: "8%", padding: "12px 15px" }}>{t("District")}</th>
                      <th style={headerStyle}>{t("Taluka")}</th>
                      <th style={{ width: "5%", padding: "12px 15px" }}>{t("Gram Panchayat")}</th>
                      <th style={{ width: "1%", padding: "12px 15px" }}>{t("Total Proposal Amount")}</th>
                      <th style={headerStyle}>{t("Remark")}</th>
                      <th style={headerStyle}>{t("Status")}</th>

                    </tr>
                  </thead>
                  <tbody>
                    {currentBills.length <= 0 ? (
                      <tr>
                        <td
                          colSpan="12"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {t("No data available")}
                        </td>
                      </tr>
                    ) : (
                      currentBills?.map((technicalInwards, index) => {
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                        return (
                          <tr
                            style={{
                              backgroundColor: bgColor,
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                            key={index}
                          >
                            <td style={{ textAlign: "center" }}>
                              {indexOfFirstBill + index + 1}
                            </td>
                            {!exportingPDF && (
                              <td style={{ textAlign: "center", padding: "12px 15px" }}>
                                <button
                                  onClick={() => nav(`/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`, {
                                    state: {
                                      type: "Proposal"
                                    }
                                  })}
                                  className='m-auto text-center'
                                  style={{
                                    width: "3.8rem", fontWeight: "600", padding: "12px 15px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                    background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                    color: 'white', borderRadius: '8px',
                                  }}
                                > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                  {t("View")}
                                </button>
                              </td>
                            )}
                            {/* <td className="py-2">
                              {technicalInwards.Proposal_fileNumber}
                            </td>
                            <td className="py-2">
                              {technicalInwards.HeadCode}
                            </td>
                            <td className="py-2">
                              {technicalInwards.Proposal_year}
                            </td>
                            <td className='py-2'>{technicalInwards.SchemeName}</td>
                            <td className="py-2">
                              {technicalInwards.District}
                            </td>
                            <td className='py-2'>{technicalInwards.Taluka}</td>
                            <td className='py-2'>{technicalInwards.Gram_panchayat}</td>
                            <td
                              style={{ padding: "8px" }}
                            >{`${technicalInwards.TotalProposalAmount}`}</td> */}


                            {/* ///////----- */}
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Work_name}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Proposal_fileNumber}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Proposal_year}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.HeadCode}</td>
                            {/* <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.SchemeName}</td> */}
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.District}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Taluka}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Gram_panchayat}</td>
                            <td className="py-2" style={{ padding: "12px 15px" }}>
                              ₹{Number(technicalInwards.TotalProposalAmount || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Remark}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Status}</td>

                          </tr>
                        );
                      })
                    )}
                    <tr
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        fontSize: "18px"
                      }}
                    >
                      <td colSpan={exportingPDF ? 8 : 9} style={{ textAlign: "right", padding: "10px" }}>
                        Page Total
                      </td>

                      <td style={{ padding: "10px" }}>
                        ₹ {pageTotalProposalAmount.toLocaleString("en-IN")}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        fontSize: "18px"
                      }}
                    >
                      <td colSpan={exportingPDF ? 8 : 9} style={{ textAlign: "right", padding: "10px" }}>
                        Gross Total
                      </td>

                      <td style={{ padding: "10px" }}>
                        ₹ {grossTotalProposalAmount.toLocaleString("en-IN")}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-12 mt-3">
                <div
                  className="my-2 d-flex justify-content-between align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p
                    className="text-gray-600"
                    style={{ fontSize: "18px", margin: 0 }}
                  >
                    {t("Showing")}{" "}
                    {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                    {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                    {t("of")} {filteredBills?.length} {t("entries")}
                  </p>
                  <div className="col-6 text-end">
                    <GooglePagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {SelectedOptions === "SendBack" && (
            <div
              className="m-auto"
              style={{
                width: "98%",
                backgroundColor: "white",
                padding: "30px 30px",
                boxShadow: "0px 0px 5px 1px #c7c9cc",
                borderRadius: "20px",
              }}
            >
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <button
                  className="btn btn-success"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    padding: "8px 18px",
                    borderRadius: "8px",
                  }}
                  disabled={loading || filteredBills.length === 0}
                  onClick={() =>
                    exportSendBackProposalsToExcel(
                      filteredBills,
                      "Proposal_Approval_SendBack.xlsx"
                    )
                  }
                >
                  {loading ? "Downloading..." : t("Download Excel")}
                </button>
                <button
                  className="btn btn-danger"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    padding: "8px 18px",
                    borderRadius: "8px",
                  }}
                  disabled={loading || filteredBills.length === 0}
                  onClick={() =>
                    downloadTableOnlyAsPDF(
                      "proposalSendback",
                      "Proposal_Approval_SendBack.pdf",
                      "Proposal Approval - Send Back"
                    )
                  }
                >
                  {loading ? "Downloading..." : t("Download PDF")}
                </button>
              </div>
              <div
                className="col-12 tableDesign"
                style={{ background: "#2C78DB", width: "100%", overflowX: "scroll" }}
              >
                <table
                  className="m-0 p-0 proposalSendback"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      style={{
                        color: "white",
                        border: "none",
                        height: "3rem",
                        fontSize: "18px",
                      }}
                    >
                      <th>Sr.No.</th>
                      <th style={{ width: "4%", textAlign: "center" }}>
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedBills.length > 0 &&
                            selectedBills.length === currentBills.length
                          }
                          className="my-auto"
                          style={{ height: "1rem", width: "1rem" }}
                        />
                      </th>
                      {/* <th style={{ width: "10%" }}>{t("Edit")}</th>
                      <th style={headerStyle}>{t("Proposal Name")}</th>
                      <th style={headerStyle}>{t("HeadCode")}</th>
                      <th style={headerStyle}>{t("Proposal Year")}</th>
                      <th style={headerStyle}>{t("District")}</th>
                      <th style={headerStyle}>{t("Taluka")}</th>
                      <th style={headerStyle}>{t("Gram Panchayat")}</th>
                      <th style={{ width: "15%" }}>
                        {t("Proposal Amount (In CR)")}
                      </th>
                      <th style={{ width: "10%" }}>{t("Remark")}</th> */}

                      <th style={{ width: '10%', padding: "12px 15px" }}>{t("View")}</th>
                      <th style={headerStyle}>{t("Proposal Name")}</th>
                      <th style={headerStyle}>{t("Proposal File Number")}</th>
                      <th style={headerStyle}>{t("Proposal Year")}</th>
                      <th style={headerStyle}>{t("HeadCode")}</th>
                      <th style={headerStyle}>{t("District")}</th>
                      <th style={headerStyle}>{t("Taluka")}</th>
                      <th style={headerStyle}>{t("Gram Panchayat")}</th>
                      <th style={headerStyle}>{t("Total Proposal Amount")}</th>
                      <th style={headerStyle}>{t("Remark")}</th>
                      <th style={headerStyle}>{t("Status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBills.length <= 0 ? (
                      <tr>
                        <td
                          colSpan="13"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {t("No data available")}
                        </td>
                      </tr>
                    ) : (
                      currentBills?.map((technicalInwards, index) => {
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                        return (
                          // <tr
                          //   style={{
                          //     backgroundColor: bgColor,
                          //     fontSize: "18px",
                          //     fontWeight: "500",
                          //     padding: "12px 15px"
                          //   }}
                          //   key={index}
                          // >
                          //   <td>{index + 1}</td>
                          //   <td style={{ textAlign: "center" }}>
                          //   <td className='py-2' style={{ textAlign: "center", width: "4%", padding: "12px 15px" }}>
                          //     <input
                          //       type="checkbox"
                          //       className="my-auto"
                          //       style={{ height: "1rem", width: "1rem" }}
                          //       checked={selectedBills.includes(
                          //         technicalInwards.ProposalID,
                          //       )}
                          //       onChange={() =>
                          //         handleCheckboxChange(
                          //           technicalInwards.ProposalID,
                          //           technicalInwards.Work_name,
                          //         )
                          //       }
                          //     />
                          //   </td>
                          //   <td className='py-2' style={{ padding: "10px 15px" }}>
                          //     <button
                          //       onClick={() => nav(`/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`)}
                          //       className='m-auto text-center'
                          //       style={{
                          //         width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                          //         background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                          //         color: 'white', borderRadius: '4px',
                          //       }}
                          //     >
                          //       {t("Edit")}
                          //     </button>
                          //   </td>
                          //   <td className="py-2">
                          //     {technicalInwards.Work_name}
                          //   </td>
                          //   <td className="py-2">
                          //     {technicalInwards.HeadCode}
                          //   </td>
                          //   <td className="py-2">
                          //     {technicalInwards.Proposal_year}
                          //   </td>
                          //   <td className="py-2">
                          //     {technicalInwards.District}
                          //   </td>
                          //   <td className='py-2'>{technicalInwards.Taluka}</td>
                          //   <td className="py-2">
                          //     {technicalInwards.Gram_panchayat}
                          //   </td>
                          //   <td
                          //     style={{ padding: "8px" }}
                          //   >{`${technicalInwards.Proposal_amount}`}</td>
                          //   <td
                          //     style={{ padding: "8px" }}
                          //   >{`${technicalInwards.Remark}`}</td>
                          // </tr>



                          <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
                            <td className='py-2' style={{ padding: "12px 15px", width: "4%" }}>{index + 1}</td>
                            <td className='py-2' style={{ textAlign: "center", width: "4%", padding: "12px 15px" }}>
                              <input
                                type="checkbox"
                                className='my-auto'
                                style={{ height: '1rem', width: '1rem' }}
                                checked={selectedBills.includes(technicalInwards.ProposalID)}
                                onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
                              />
                            </td>
                            {/* <td className='py-2'> */}
                            <td className='py-2' style={{ padding: "10px 15px" }}>
                              <button
                                onClick={() => nav(`/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`)}
                                className='m-auto text-center'
                                style={{
                                  width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                  background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                  color: 'white', borderRadius: '4px',
                                }}
                              >
                                {t("Edit")}
                              </button>
                            </td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Work_name}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Proposal_fileNumber}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Proposal_year}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.HeadCode}</td>
                            {/* <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.SchemeName}</td> */}
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.District}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Taluka}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Gram_panchayat}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{`${technicalInwards.TotalProposalAmount}`}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Remark || "-"}</td>
                            <td className='py-2' style={{ padding: '12px 15px' }}>{technicalInwards.Status}</td>
                          </tr>



                        );
                      })
                    )}
                  
                  </tbody>
                </table>
              </div>

              <div className="col-12 mt-3">
                <div
                  className="my-2 d-flex justify-content-between align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p
                    className="text-gray-600"
                    style={{ fontSize: "18px", margin: 0 }}
                  >
                    {t("Showing")}{" "}
                    {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                    {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                    {t("of")} {filteredBills?.length} {t("entries")}
                  </p>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <GooglePagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  </div>

                  <div
                    className="col-6 text-start"
                    style={{ display: "flex", justifyContent: "left" }}
                  >
                    <button
                      onClick={() => approveorrejectSelected("Approved")}
                      disabled={selectedBills.length <= 0 ? true : loading}
                      className="ms-0"
                      // onClick={(e) => { SetGenerateToken(false) }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        backgroundColor:
                          selectedBills.length <= 0
                            ? "rgba(141, 141, 141, 0.97)"
                            : "#39B54A",
                        color: "white",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      <img
                        src="/Approve-Selected32.png"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          filter: "brightness(0) invert(1)",
                        }}
                      />{" "}
                      {loading ? "Processing..." : "Approve Selected"}
                    </button>

                    <button
                      onClick={() => setRejectpanelhide(2)}
                      // onClick={(e) => { SetGenerateRejectToken(false) }}
                      disabled={selectedBills.length <= 0 ? true : loading}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        background:
                          selectedBills.length <= 0
                            ? "rgba(141, 141, 141, 0.97)"
                            : "#C1272D",
                        color: "white",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      <img
                        src="/Reject-Selected32.png"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          filter: "brightness(0) invert(1)",
                        }}
                      />{" "}
                      {loading ? "Processing..." : "Reject Selected"}
                    </button>

                    {adminData.Role !== "Deputy Engineer" && (
                      <button
                        onClick={() => setRejectpanelhide(3)}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          background:
                            selectedBills.length <= 0
                              ? "rgba(141, 141, 141, 0.97)"
                              : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                          color: "white",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src="/Send-Back-Selected32.png"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            filter: "brightness(0) invert(1)",
                          }}
                        />{" "}
                        {loading ? "Processing..." : "Send Back Selected"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
           {
                        SelectedOptions === "" && (
                            <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                                                 <div
    className="col-12 mb-3"
    style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
    }}
>
    <button
        className="btn btn-success"
        style={{
            fontSize: "18px",
            fontWeight: "600",
            padding: "8px 18px",
            borderRadius: "8px",
        }}
        disabled={loading || filteredBills.length === 0}
        onClick={() =>
            exportPendingProposalsToExcel(
                filteredBills,
                "Proposal_all_list.xlsx"
            )
        }
    >
        {loading ? "Downloading..." : t("Download Excel")}
    </button>
     <button
        className="btn btn-danger"
        style={{
            fontSize: "18px",
            fontWeight: "600",
            padding: "8px 18px",
            borderRadius: "8px",
        }}
        disabled={loading || filteredBills.length === 0}
        onClick={() =>
            downloadTableOnlyAsPDF(
                "proposalpending",
                "Proposal_All.pdf",
                "Proposal All"
            )
        }
    >
        {loading ? "Downloading..." : t("Download PDF")}
    </button>
</div>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB',overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}>
                                    <table className='m-0 p-0 proposalpending' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                                <th style={{ width: "8%" }}>{t("Sr.No.")}</th>
                                                <th style={{ width: "8%" }}>{t("View")}</th>
                                                {/* <th style={{ width: "15%" }}>Proposal Work Name</th> */}
                                                <th style={{ width: "10%" }}>{t("Proposal File Number")}</th>
                                                <th style={{ width: "20%" }}>{t("HeadCode")}</th>
                                                <th style={{ width: "7%" }}>{t("Year")}</th>
                                                {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
                                                <th style={{ width: "8%" }}>{t("District")}</th>
                                                {/* <th style={{ width: "8%" }}>Gram Panchayat</th> */}
                                                <th style={{ width: "14%" }}>{t("Total Proposal Amount")}</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentBills.length <= 0 ?
                                                    (
                                                        <tr>
                                                            <td colSpan="12" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                                {t("No data available")}
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    (
                                                        currentBills?.map((technicalInwards, index) => {
                                                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                            return (
                                                                <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
                                                                    <td style={{ textAlign: "center" }}>{indexOfFirstBill + index + 1}</td>
                                                                    <td className='py-2'>
                                                                        <button
                                                                            onClick={() => nav(`/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`, {
                                                                                state: {
                                                                                    type: "Proposal"
                                                                                }
                                                                            })}
                                                                            className='m-auto text-center'
                                                                            style={{
                                                                                width: "3.8rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                                color: 'white', borderRadius: '8px',
                                                                            }}
                                                                        > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                                                            {t("View")}
                                                                        </button>
                                                                    </td>
                                                                    <td className='py-2'>{technicalInwards.Proposal_fileNumber}</td>
                                                                    <td className='py-2'>{technicalInwards.HeadCode}</td>
                                                                    <td className='py-2'>{technicalInwards.Proposal_year}</td>
                                                                    <td className='py-2'>{technicalInwards.District}</td>
                                                                    <td style={{ padding: "8px" }}>
  ₹{Number(technicalInwards.TotalProposalAmount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>
                                                                </tr>
                                                            )
                                                        })
                                                    )
                                            }
                                        {/* Page Total */}
<tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", fontSize: "18px" }}>
  <td colSpan="6" style={{ textAlign: "right", padding: "10px" }}>
    Page Total
  </td>
  <td style={{ padding: "10px" }}>
    ₹ {pageTotalProposalAmount.toLocaleString("en-IN")}
  </td>
</tr>

{/* Gross Total */}
<tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", fontSize: "18px" }}>
  <td colSpan="6" style={{ textAlign: "right", padding: "10px" }}>
    Gross Total
  </td>
  <td style={{ padding: "10px" }}>
    ₹ {grossTotalProposalAmount.toLocaleString("en-IN")}
  </td>
</tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className='col-12 mt-3'>

                                    <div
                                        className="my-2 d-flex justify-content-between align-items-center"
                                        style={{ flexWrap: "wrap" }}
                                    >

                                        <p className="text-gray-600" style={{ fontSize: "18px", margin: 0 }}>{t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)} {t("of")} {filteredBills?.length} {t("entries")}</p>
                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            <GooglePagination
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={setCurrentPage}
/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
        </div>

        {rejectPanelhide === 2 && (
          <div className="col-12 RejectPanelContainer">
            <div className="Rejectpanel">
              <form action="">
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        {t("Remark")} <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        name=""
                        id=""
                        placeholder={t("Enter Remark")}
                        onChange={(e) => setRemark(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-9 m-auto">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          background:
                            "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          width: "5rem",
                          height: "2rem",
                          fontSize: "18px",
                        }}
                        onClick={() => approveorrejectSelected("Rejected")}
                      >
                        <img src={submit} style={{ width: "15px" }} /> Reject
                      </button>
                      <button
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          backgroundColor: "#f1594c",
                          width: "6rem",
                          height: "2rem",
                          fontSize: "16px",
                        }}
                        onClick={() => window.location.reload()}
                      >
                        {" "}
                        <img src={Cancel32} style={{ width: "17px" }} />
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {rejectPanelhide === 3 && (
          <div className="col-12 RejectPanelContainer">
            <div className="Rejectpanel">
              <form action="">
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        {t("Remark")} <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        name=""
                        id=""
                        placeholder={t("Enter Remark")}
                        onChange={(e) => setRemark(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  {/* <div className="col-3"></div> */}
                  <div className="col-9 m-auto">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          background:
                            "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          width: "8rem",
                          height: "2rem",
                          fontSize: "18px",
                        }}
                        onClick={() => approveorrejectSelected("SendBack")}
                      >
                        <img src={submit} style={{ width: "15px" }} /> Send Back
                      </button>
                      <button
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          backgroundColor: "#f1594c",
                          width: "6rem",
                          height: "2rem",
                          fontSize: "16px",
                        }}
                        onClick={() => window.location.reload()}
                      >
                        {" "}
                        <img src={Cancel32} style={{ width: "17px" }} />
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProposalInwardList;


//--> old code
// import React, { useState, useEffect, useContext } from "react";
// import AdminContext from "../../StateContext/Application";
// import { apiurl } from "../../../../path";
// import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import "./rejectpanel.css";
// import {
//   Back32,
//   Cancel32,
//   ProposalCreation32,
//   submit,
// } from "../../../../public/LoginImages/importimages";
// import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
// import GooglePagination from "../../styles/GooglePagination";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// const ProposalInwardList = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const {
//     GetProposalInwardsList,
//     ProposalApprovalOperation,
//     CreateToken,
//     Usermenu,
//   } = context;

//   const nav = useNavigate();
//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [rejectPanelhide, setRejectpanelhide] = useState(1);
//   const [remark, setRemark] = useState("");
//   const [SelectedOptions, setSelectedOptions] = useState("Pending");
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const billsPerPage = 10;
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(() => {
//     const page = searchParams.get("page");
//     return page ? parseInt(page) : 1;
//   });

//   const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const [exportingPDF, setExportingPDF] = useState(false);

//   const sortedBills = filteredBills;
//   // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
//   // const sortedBills = Array.isArray(filteredBills)
//   //   ? filteredBills
//   //       .slice() // ✅ prevent state mutation
//   //       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//   //   : [];
//   const currentBills = sortedBills.slice(indexOfFirstBill, indexOfLastBill);

//   const [hide, sethide] = useState(true);
//   const [Etoken, SetEtoken] = useState(false);
//   const [GenerateToken, SetGenerateToken] = useState(true);
//   const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);
//   const [selectedWorkNames, setSelectedWorkNames] = useState([]);
//   const [SelectedProposalDetail, setSelectedProposalDetail] = useState([]);
//   const headerStyle = {
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };

//   const [adminData, setAdminData] = useState([]);

//   const GetAdminData = async () => {
//     try {
//       let data = await Usermenu();
//       console.log("data ------------", data);

//       if (!data || typeof data !== "object") {
//         console.error("Invalid data:", data);
//         return [];
//       }

//       const userData = data.Data; // ← Access Data object
//       const menuList = data.result || []; // ← Access menu list

//       setAdminData(userData);

//       console.log("User Data:", userData);
//       console.log("Menus:", menuList);
//     } catch (err) {
//       console.error("Error in GetAdminData:", err);
//     }
//   };
//   useEffect(() => {
//     GetAdminData();
//   }, []);
//   async function GenerateTokenFor(e) {
//     e.preventDefault();
//     let data = await CreateToken("Proposal Approval");
//     document.getElementById("tokencopys").innerText = data;
//     SetEtoken(data);
//     sethide(false);
//   }

//   const getTechnicalInwardsList = async () => {
//     let data = (await GetProposalInwardsList("All", "All")) || [];
//     console.log("data------------", data);
//     setTechnicalInwards(data);
//     setFilteredBills(data);
//   };

//   useEffect(() => {
//     getTechnicalInwardsList();
//   }, []);

//   let inwardList = [];
//   if (technicalInwards && technicalInwards.length > 0) {
//     inwardList = technicalInwards;
//   }

//   useEffect(() => {
//     const lowerSearchTerm = searchTerm.toLowerCase();
//     const filtered = technicalInwards.filter((bill) =>
//       Object.values(bill).some((val) =>
//         (val || "").toString().toLowerCase().includes(lowerSearchTerm),
//       ),
//     );
//     setFilteredBills(filtered);
//     // setCurrentPage(1);
//   }, [searchTerm, technicalInwards]);

//   useEffect(() => {
//     const page = parseInt(searchParams.get("page")) || 1;
//     if (totalPages > 0 && page > totalPages) {
//       setCurrentPage(totalPages);
//       setSearchParams({ page: totalPages });
//     } else if (page < 1) {
//       setCurrentPage(1);
//       setSearchParams({ page: 1 });
//     }
//   }, [searchParams, totalPages, setSearchParams]);

//   // useEffect(() => {
//   //     if (technicalInwards) {
//   //         let res = technicalInwards.filter((item) => item.Status == SelectedOptions );
//   //         setFilteredBills(res);
//   //     }
//   // }, [SelectedOptions, technicalInwards])
//   useEffect(() => {
//     if (!technicalInwards) return;

//     let res = technicalInwards;

//     if (SelectedOptions === "Pending") {
//       // ONLY when All → make unique by workuniqueid
//       const uniqueMap = new Map();
//       technicalInwards.forEach((item) => {
//         uniqueMap.set(item.workuniqueid, item);
//       });
//       res = Array.from(uniqueMap.values());
//     } else {
//       // For sendback / pending / approved etc → normal filter
//       res = technicalInwards.filter((item) => item.Status === SelectedOptions);
//     }

//     setFilteredBills(res);
//   }, [SelectedOptions, technicalInwards]);

//   useEffect(() => {
//     if (selectedBills.length > 0) {
//       const selectedDetails = technicalInwards.filter((item) =>
//         selectedBills.includes(item.ProposalID),
//       );
//       setSelectedProposalDetail(selectedDetails);
//     } else {
//       setSelectedProposalDetail([]);
//     }
//   }, [selectedBills, technicalInwards]);

//   const handleCheckboxChange = (proposalId, workName) => {
//     if (selectedBills.includes(proposalId)) {
//       setSelectedBills(selectedBills.filter((id) => id !== proposalId));
//       setSelectedWorkNames(
//         selectedWorkNames.filter((name) => name !== workName),
//       );
//     } else {
//       setSelectedBills([...selectedBills, proposalId]);
//       setSelectedWorkNames([...selectedWorkNames, workName]);
//     }
//   };

//   const handleSelectAll = (event) => {
//     if (event.target.checked) {
//       setSelectedBills(currentBills.map((bill) => bill.ProposalID));
//       setSelectedWorkNames(currentBills.map((bill) => bill.Work_name));
//     } else {
//       setSelectedBills([]);
//       setSelectedWorkNames([]);
//     }
//   };

//   const approveorrejectSelected = async (condition) => {
//     if (selectedBills.length === 0) {
//       alert("No Proposal selected for approval!");
//       return;
//     }
//     setLoading(true);
//     if (condition == "Rejected") {
//       const cleanRemark = remark.trim().replace(/\s+/g, " ");

//       // ❌ If remark is empty after trimming
//       if (!cleanRemark) {
//         alert("Remark is required and cannot be empty!");
//         return;
//       }
//     }
//     try {
//       let response = await ProposalApprovalOperation(
//         selectedBills,
//         condition,
//         remark,
//         Etoken,
//         selectedWorkNames,
//         SelectedProposalDetail,
//       ); // Call backend function
//       if (response.message) {
//         alert(response.message);
//         //--> added reload
//         window.location.reload()
//         setRemark("");
//         setRejectpanelhide(false);
//         getTechnicalInwardsList(); // Refresh the list after approval
//       }
//       if (response.error) {
//         console.log("response error", response.error);
//         alert(response.error);
//         // window.location.reload()
//         getTechnicalInwardsList(); // Refresh the list after approval
//       }
//     } catch (error) {
//       console.error("Error approving Proposal:", error);
//       alert("An error occurred while approving bills.");
//     }
//     setLoading(false); // Stop loader
//   };

//   const exportPendingProposalsToExcel = async (
//     bills,
//     filename = "Proposal_Approval_Pending.xlsx"
// ) => {
//     if (!bills || bills.length === 0) {
//         alert("No data available");
//         return;
//     }

//     setLoading(true);

//     await new Promise((resolve) => setTimeout(resolve, 500));

//     try {
//         const excelData = bills.map((proposal, index) => ({
//             "Sr.No.": index + 1,
//             "Proposal File Number": proposal.Proposal_fileNumber || "",
//             "HeadCode": proposal.HeadCode || "",
//             "Year": proposal.Proposal_year || "",
//             "District": proposal.District || "",
//             "Total Proposal Amount": Number(
//                 proposal.TotalProposalAmount || 0
//             ),
//         }));

//         // Total Row
//         const totalRow = {
//             "Sr.No.": "Total",
//             "Proposal File Number": "",
//             "HeadCode": "",
//             "Year": "",
//             "District": "",
//             "Total Proposal Amount": bills.reduce(
//                 (sum, item) =>
//                     sum + Number(item.TotalProposalAmount || 0),
//                 0
//             ),
//         };

//         excelData.push(totalRow);

//         const worksheet = XLSX.utils.json_to_sheet(excelData);

//         // Column widths
//         worksheet["!cols"] = [
//             { wch: 10 }, // Sr.No.
//             { wch: 25 }, // Proposal File Number
//             { wch: 35 }, // HeadCode
//             { wch: 12 }, // Year
//             { wch: 25 }, // District
//             { wch: 25 }, // Total Proposal Amount
//         ];

//         // Freeze header
//         worksheet["!freeze"] = {
//             xSplit: 0,
//             ySplit: 1,
//         };

//         // Filter
//         worksheet["!autofilter"] = {
//             ref: XLSX.utils.encode_range({
//                 s: { r: 0, c: 0 },
//                 e: {
//                     r: excelData.length - 1,
//                     c: Object.keys(excelData[0]).length - 1,
//                 },
//             }),
//         };

//         const workbook = XLSX.utils.book_new();

//         XLSX.utils.book_append_sheet(
//             workbook,
//             worksheet,
//             "Pending Proposals"
//         );

//         XLSX.writeFile(workbook, filename);

//     } catch (error) {
//         console.error(
//             "Pending Proposal Excel Export Error:",
//             error
//         );
//         alert("Error while downloading Excel");
//     } finally {
//         setLoading(false);
//     }
// };


// const exportSendBackProposalsToExcel = async (
//     bills,
//     filename = "Proposal_Approval_SendBack.xlsx"
// ) => {
//     if (!bills || bills.length === 0) {
//         alert("No data available");
//         return;
//     }

//     setLoading(true);

//     await new Promise((resolve) => setTimeout(resolve, 500));

//     try {
//         const excelData = bills.map((proposal, index) => ({
//             "Sr.No.": index + 1,
//             "Proposal Name": proposal.Work_name || "",
//             "HeadCode": proposal.HeadCode || "",
//             "Proposal Year": proposal.Proposal_year || "",
//             "District": proposal.District || "",
//             "Gram Panchayat": proposal.Gram_panchayat || "",
//             "Proposal Amount (In CR)": Number(
//                 proposal.Proposal_amount || 0
//             ),
//             "Remark": proposal.Remark || "",
//         }));

//         // Total Row
//         const totalRow = {
//             "Sr.No.": "Total",
//             "Proposal Name": "",
//             "HeadCode": "",
//             "Proposal Year": "",
//             "District": "",
//             "Gram Panchayat": "",
//             "Proposal Amount (In CR)": bills.reduce(
//                 (sum, item) =>
//                     sum + Number(item.Proposal_amount || 0),
//                 0
//             ),
//             "Remark": "",
//         };

//         excelData.push(totalRow);

//         const worksheet = XLSX.utils.json_to_sheet(excelData);

//         // Column widths
//         worksheet["!cols"] = [
//             { wch: 10 }, // Sr.No.
//             { wch: 40 }, // Proposal Name
//             { wch: 35 }, // HeadCode
//             { wch: 15 }, // Proposal Year
//             { wch: 25 }, // District
//             { wch: 25 }, // Gram Panchayat
//             { wch: 25 }, // Proposal Amount
//             { wch: 40 }, // Remark
//         ];

//         // Freeze header
//         worksheet["!freeze"] = {
//             xSplit: 0,
//             ySplit: 1,
//         };

//         // Filter
//         worksheet["!autofilter"] = {
//             ref: XLSX.utils.encode_range({
//                 s: { r: 0, c: 0 },
//                 e: {
//                     r: excelData.length - 1,
//                     c: Object.keys(excelData[0]).length - 1,
//                 },
//             }),
//         };

//         const workbook = XLSX.utils.book_new();

//         XLSX.utils.book_append_sheet(
//             workbook,
//             worksheet,
//             "Send Back Proposals"
//         );

//         XLSX.writeFile(workbook, filename);

//     } catch (error) {
//         console.error(
//             "Send Back Proposal Excel Export Error:",
//             error
//         );
//         alert("Error while downloading Excel");
//     } finally {
//         setLoading(false);
//     }
// };
//  const downloadTableOnlyAsPDF = async (
//     tableClass,
//     filename,
//     title,
//     chunkSize = 500, // 🔥 300–500 recommended
//   ) => {
//     const originalTable = document.querySelector(`.${tableClass}`);
//     if (!originalTable) {
//       setExportingPDF(false);
//       return;
//     }

//     setLoading(true);
//     setExportingPDF(true);

//     // Allow loader to render first
//     await new Promise((resolve) => setTimeout(resolve, 600));

//     try {
//       const originalRows = originalTable.querySelectorAll("tbody tr");
//       const totalRows = originalRows.length;

//       if (!totalRows) {
//         setLoading(false);
//         setExportingPDF(false);
//         return;
//       }

//       for (let start = 0; start < totalRows; start += chunkSize) {
//         const end = Math.min(start + chunkSize, totalRows);

//         // 🔥 Clone table cleanly
//         const tableClone = originalTable.cloneNode(true);
//         const rows = tableClone.querySelectorAll("tbody tr");

//         // Remove rows outside current chunk
//         rows.forEach((row, index) => {
//           if (index < start || index >= end) {
//             row.remove();
//           }
//         });

//         // Hide cloned table from view
//         tableClone.style.position = "absolute";
//         tableClone.style.left = "-9999px";
//         tableClone.style.top = "0";
//         document.body.appendChild(tableClone);

//         const pdf = new jsPDF("p", "mm", "a4");
//         const pageWidth = pdf.internal.pageSize.getWidth();
//         const pageHeight = pdf.internal.pageSize.getHeight();

//         const topMargin = 25;
//         const sideMargin = 10;
//         const bottomMargin = 15;

//         pdf.setFontSize(16);
//         pdf.setFont("helvetica", "bold");
//         pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
//           align: "center",
//         });

//         const canvas = await html2canvas(tableClone, {
//           scale: 1,
//           useCORS: true,
//           backgroundColor: "#2C78DB",
//         });

//         const imgWidth = pageWidth - sideMargin * 2;
//         const pxToMm = imgWidth / canvas.width;

//         const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//         const usablePageHeightPx = usablePageHeightMm / pxToMm;

//         let renderedHeight = 0;
//         let pageNumber = 0;

//         while (renderedHeight < canvas.height) {
//           const sliceHeight = Math.min(
//             usablePageHeightPx,
//             canvas.height - renderedHeight,
//           );

//           const pageCanvas = document.createElement("canvas");
//           const context = pageCanvas.getContext("2d");

//           pageCanvas.width = canvas.width;
//           pageCanvas.height = sliceHeight;

//           context.drawImage(
//             canvas,
//             0,
//             renderedHeight,
//             canvas.width,
//             sliceHeight,
//             0,
//             0,
//             canvas.width,
//             sliceHeight,
//           );

//           const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

//           if (pageNumber > 0) pdf.addPage();

//           pdf.addImage(
//             imgData,
//             "JPEG",
//             sideMargin,
//             topMargin,
//             imgWidth,
//             sliceHeight * pxToMm,
//           );

//           renderedHeight += sliceHeight;
//           pageNumber++;
//         }

//         pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

//         document.body.removeChild(tableClone);

//         // Small delay prevents UI freezing
//         await new Promise((resolve) => setTimeout(resolve, 300));
//       }
//     } catch (error) {
//       console.error("PDF Export Error:", error);
//     } finally {
//       setExportingPDF(false);
//       setLoading(false);
//     }
//   };
//   return (
//     <>
//       <div
//         className="col-12"
//         style={{
//           backgroundColor: "#EFF3F8",
//           height: "90vh",
//           overflowX: "hidden",
//           overflowY: "scroll",
//         }}
//       >
//         <div className="col-12 px-3 m-auto">
//           <div
//             className="col-12 px-4 mb-4 mt-3"
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
//             <h5 className="my-auto fw-bold">
//               <img
//                 src="/GR-Approval64.png"
//                 alt="Technical Approval"
//                 style={{ width: "24px", height: "24px" }}
//                 className="my-auto me-1"
//               />
//               <span className="my-auto">{t("Proposal Approval")}</span>
//             </h5>
//             <div
//               style={{
//                 position: "relative",
//                 width: "250px",
//                 marginRight: "10px",
//               }}
//             >
//               <img
//                 src="/Search32.png"
//                 alt="Search Icon"
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "10px",
//                   transform: "translateY(-50%)",
//                   width: "16px",
//                   height: "16px",
//                   opacity: 0.6,
//                 }}
//               />
//               <input
//                 type="text"
//                 placeholder={t("Search Here")}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 value={searchTerm}
//                 style={{
//                   width: "100%",
//                   padding: "8px 12px 8px 32px", // left padding makes space for icon
//                   border: "1px solid #ccc",
//                   borderRadius: "8px",
//                   backgroundColor: "#f1f6fc",
//                   fontSize: "18px",
//                   color: "#333",
//                   boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                   outline: "none",
//                 }}
//               />
//             </div>
//           </div>

//           <div className="col-12 my-4">
//             <div
//               className="col-12 py-4 "
//               style={{
//                 background: "linear-gradient(to right, #c8d0e3, #b7dff5)",
//                 borderRadius: "10px",
//               }}
//             >
//               <div className="col-8 m-auto">
//                 <div className="row align-items-center">
//                   <div className="col-4 text-end">
//                     <label className="fw-bold">{t("Select Status")}</label>
//                   </div>

//                   <div className="col-6">
//                     <select
//                       className="w-100 py-2 px-3"
//                       style={{
//                         border: "none",
//                         borderRadius: "6px",
//                         outline: "none",
//                         fontSize: "18px",
//                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                       }}
//                       onChange={(e) => setSelectedOptions(e.target.value)}
//                     >
//                       <option value="Pending">{t("All")}</option>
//                       {adminData.Role !== "Additional CEO" && (
//                         <option value="SendBack">{t("Send Back")}</option>
//                       )}
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {SelectedOptions === "Pending" && (
//             <div
//               className="m-auto"
//               style={{
//                 width: "98%",
//                 backgroundColor: "white",
//                 padding: "30px 30px",
//                 boxShadow: "0px 0px 5px 1px #c7c9cc",
//                 borderRadius: "20px",
//               }}
//             >
//                                                                <div
//     className="col-12 mb-3"
//     style={{
//         display: "flex",
//         justifyContent: "flex-end",
//         alignItems: "center",
//         gap: "10px",
//     }}
// >
//     <button
//         className="btn btn-success"
//         style={{
//             fontSize: "18px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             borderRadius: "8px",
//         }}
//         disabled={loading || filteredBills.length === 0}
//         onClick={() =>
//             exportPendingProposalsToExcel(
//                 filteredBills,
//                 "Proposal_Approval_Pending.xlsx"
//             )
//         }
//     >
//         {loading ? "Downloading..." : t("Download Excel")}
//     </button>
//      <button
//         className="btn btn-danger"
//         style={{
//             fontSize: "18px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             borderRadius: "8px",
//         }}
//         disabled={loading || filteredBills.length === 0}
//         onClick={() =>
//             downloadTableOnlyAsPDF(
//                 "proposalpending",
//                 "Proposal_Approval_Pending.pdf",
//                 "Proposal Approval - Pending"
//             )
//         }
//     >
//         {loading ? "Downloading..." : t("Download PDF")}
//     </button>
// </div>
//               <div
//                 className="col-12 tableDesign"
//                 style={{ background: "#2C78DB" }}
//               >
//                 <table
//                   className="m-0 p-0 proposalpending"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       style={{
//                         color: "white",
//                         border: "none",
//                         height: "3rem",
//                         fontSize: "18px",
//                       }}
//                     >
//                       <th style={{ width: "8%" }}>{t("Sr.No.")}</th>
//                       <th style={{ width: "8%" }}>{t("View")}</th>
//                       {/* <th style={{ width: "15%" }}>Proposal Work Name</th> */}
//                       <th style={{ width: "10%" }}>
//                         {t("Proposal File Number")}
//                       </th>
//                       <th style={{ width: "20%" }}>{t("HeadCode")}</th>
//                       <th style={{ width: "7%" }}>{t("Year")}</th>
//                       {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
//                       <th style={{ width: "8%" }}>{t("District")}</th>
//                       {/* <th style={{ width: "8%" }}>Gram Panchayat</th> */}
//                       <th style={{ width: "14%" }}>
//                         {t("Total Proposal Amount")}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentBills.length <= 0 ? (
//                       <tr>
//                         <td
//                           colSpan="12"
//                           style={{
//                             textAlign: "center",
//                             padding: "20px",
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           {t("No data available")}
//                         </td>
//                       </tr>
//                     ) : (
//                       currentBills?.map((technicalInwards, index) => {
//                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                         return (
//                           <tr
//                             style={{
//                               backgroundColor: bgColor,
//                               fontSize: "18px",
//                               fontWeight: "500",
//                             }}
//                             key={index}
//                           >
//                             <td style={{ textAlign: "center" }}>
//                               {indexOfFirstBill + index + 1}
//                             </td>
//                             <td className="py-2">
//                               <button
//                                 onClick={() =>
//                                   nav(
//                                     `/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`,
//                                     {
//                                       state: {
//                                         type: "Proposal",
//                                       },
//                                     },
//                                   )
//                                 }
//                                 className="m-auto text-center"
//                                 style={{
//                                   width: "3.8rem",
//                                   fontWeight: "600",
//                                   padding: "7px 3px",
//                                   display: "flex",
//                                   justifyContent: "center",
//                                   alignItems: "center",
//                                   gap: "0.1rem",
//                                   background:
//                                     "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
//                                   color: "white",
//                                   borderRadius: "8px",
//                                 }}
//                               >
//                                 {" "}
//                                 <img
//                                   src="/view32.png"
//                                   style={{
//                                     width: "0.9rem",
//                                     height: "0.9rem",
//                                     filter: "brightness(0) invert(1)",
//                                   }}
//                                 />
//                                 {t("View")}
//                               </button>
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.Proposal_fileNumber}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.HeadCode}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.Proposal_year}
//                             </td>
//                             {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
//                             <td className="py-2">
//                               {technicalInwards.District}
//                             </td>
//                             {/* <td className='py-2'>{technicalInwards.Gram_panchayat}</td> */}
//                             <td
//                               style={{ padding: "8px" }}
//                             >{`${technicalInwards.TotalProposalAmount}`}</td>
//                           </tr>
//                         );
//                       })
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="col-12 mt-3">
//                 <div
//                   className="my-2 d-flex justify-content-between align-items-center"
//                   style={{ flexWrap: "wrap" }}
//                 >
//                   <p
//                     className="text-gray-600"
//                     style={{ fontSize: "18px", margin: 0 }}
//                   >
//                     {t("Showing")}{" "}
//                     {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
//                     {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
//                     {t("of")} {filteredBills?.length} {t("entries")}
//                   </p>
//                   <div className="col-6 text-end">
//                     <GooglePagination
//                       currentPage={currentPage}
//                       totalPages={totalPages}
//                       onPageChange={setCurrentPage}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {SelectedOptions === "SendBack" && (
//             <div
//               className="m-auto"
//               style={{
//                 width: "98%",
//                 backgroundColor: "white",
//                 padding: "30px 30px",
//                 boxShadow: "0px 0px 5px 1px #c7c9cc",
//                 borderRadius: "20px",
//               }}
//             >
//                                                                         <div
//     className="col-12 mb-3"
//     style={{
//          display: "flex",
//         justifyContent: "flex-end",
//         alignItems: "center",
//         gap: "10px",
//     }}
// >
//     <button
//         className="btn btn-success"
//         style={{
//             fontSize: "18px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             borderRadius: "8px",
//         }}
//         disabled={loading || filteredBills.length === 0}
//         onClick={() =>
//             exportSendBackProposalsToExcel(
//                 filteredBills,
//                 "Proposal_Approval_SendBack.xlsx"
//             )
//         }
//     >
//         {loading ? "Downloading..." : t("Download Excel")}
//     </button>
//      <button
//         className="btn btn-danger"
//         style={{
//             fontSize: "18px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             borderRadius: "8px",
//         }}
//         disabled={loading || filteredBills.length === 0}
//         onClick={() =>
//             downloadTableOnlyAsPDF(
//                 "proposalSendback",
//                 "Proposal_Approval_SendBack.pdf",
//                 "Proposal Approval - Send Back"
//             )
//         }
//     >
//         {loading ? "Downloading..." : t("Download PDF")}
//     </button>
// </div>
//               <div
//                 className="col-12 tableDesign"
//                 style={{ background: "#2C78DB",width:"100%",overflowX:"scroll"  }}
//               >
//                 <table
//                   className="m-0 p-0 proposalSendback"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       style={{
//                         color: "white",
//                         border: "none",
//                         height: "3rem",
//                         fontSize: "18px",
//                       }}
//                     >
//                       <th>Sr.No.</th>
//                       <th style={{ width: "4%", textAlign: "center" }}>
//                         <input
//                           type="checkbox"
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedBills.length > 0 &&
//                             selectedBills.length === currentBills.length
//                           }
//                           className="my-auto"
//                           style={{ height: "1rem", width: "1rem" }}
//                         />
//                       </th>
//                       <th style={{ width: "10%" }}>{t("Edit")}</th>
//                       <th style={headerStyle}>{t("Proposal Name")}</th>
//                       <th style={headerStyle}>{t("HeadCode")}</th>
//                       <th style={headerStyle}>{t("Proposal Year")}</th>
//                       <th style={headerStyle}>{t("District")}</th>
//                       <th style={headerStyle}>{t("Gram Panchayat")}</th>
//                       <th style={{ width: "15%" }}>
//                         {t("Proposal Amount (In CR)")}
//                       </th>
//                       <th style={{ width: "10%" }}>{t("Remark")}</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentBills.length <= 0 ? (
//                       <tr>
//                         <td
//                           colSpan="12"
//                           style={{
//                             textAlign: "center",
//                             padding: "20px",
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           {t("No data available")}
//                         </td>
//                       </tr>
//                     ) : (
//                       currentBills?.map((technicalInwards, index) => {
//                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                         return (
//                           <tr
//                             style={{
//                               backgroundColor: bgColor,
//                               fontSize: "18px",
//                               fontWeight: "500",
//                             }}
//                             key={index}
//                           >
//                             <td>{index + 1}</td>
//                             <td style={{ textAlign: "center" }}>
//                               <input
//                                 type="checkbox"
//                                 className="my-auto"
//                                 style={{ height: "1rem", width: "1rem" }}
//                                 checked={selectedBills.includes(
//                                   technicalInwards.ProposalID,
//                                 )}
//                                 onChange={() =>
//                                   handleCheckboxChange(
//                                     technicalInwards.ProposalID,
//                                     technicalInwards.Work_name,
//                                   )
//                                 }
//                               />
//                             </td>
//                             <td className="py-2">
//                               <button
//                                 onClick={() =>
//                                   nav(
//                                     `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
//                                   )
//                                 }
//                                 className="m-auto text-center"
//                                 style={{
//                                   width: "4rem",
//                                   fontWeight: "600",
//                                   padding: "7px 3px",
//                                   display: "flex",
//                                   justifyContent: "center",
//                                   alignItems: "center",
//                                   gap: "0.1rem",
//                                   background:
//                                     "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
//                                   color: "white",
//                                   borderRadius: "4px",
//                                 }}
//                               >
//                                 {t("Edit")}
//                               </button>
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.Work_name}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.HeadCode}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.Proposal_year}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.District}
//                             </td>
//                             <td className="py-2">
//                               {technicalInwards.Gram_panchayat}
//                             </td>
//                             <td
//                               style={{ padding: "8px" }}
//                             >{`${technicalInwards.Proposal_amount}`}</td>
//                             <td
//                               style={{ padding: "8px" }}
//                             >{`${technicalInwards.Remark}`}</td>
//                           </tr>
//                         );
//                       })
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="col-12 mt-3">
//                 <div
//                   className="my-2 d-flex justify-content-between align-items-center"
//                   style={{ flexWrap: "wrap" }}
//                 >
//                   <p
//                     className="text-gray-600"
//                     style={{ fontSize: "18px", margin: 0 }}
//                   >
//                     {t("Showing")}{" "}
//                     {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
//                     {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
//                     {t("of")} {filteredBills?.length} {t("entries")}
//                   </p>
//                   <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                     <GooglePagination
//                       currentPage={currentPage}
//                       totalPages={totalPages}
//                       onPageChange={setCurrentPage}
//                     />
//                   </div>

//                   <div
//                     className="col-6 text-start"
//                     style={{ display: "flex", justifyContent: "left" }}
//                   >
//                     <button
//                       onClick={() => approveorrejectSelected("Approved")}
//                       disabled={selectedBills.length <= 0 ? true : loading}
//                       className="ms-0"
//                       // onClick={(e) => { SetGenerateToken(false) }}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.3rem",
//                         margin: "12px",
//                         padding: "8px 10px",
//                         fontWeight: "600",
//                         backgroundColor:
//                           selectedBills.length <= 0
//                             ? "rgba(141, 141, 141, 0.97)"
//                             : "#39B54A",
//                         color: "white",
//                         borderRadius: "8px",
//                         cursor:
//                           selectedBills.length <= 0
//                             ? "not-allowed"
//                             : loading
//                               ? "not-allowed"
//                               : "pointer",
//                       }}
//                     >
//                       <img
//                         src="/Approve-Selected32.png"
//                         style={{
//                           width: "1rem",
//                           height: "1rem",
//                           filter: "brightness(0) invert(1)",
//                         }}
//                       />{" "}
//                       {loading ? "Processing..." : "Approve Selected"}
//                     </button>

//                     <button
//                       onClick={() => setRejectpanelhide(2)}
//                       // onClick={(e) => { SetGenerateRejectToken(false) }}
//                       disabled={selectedBills.length <= 0 ? true : loading}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "0.3rem",
//                         margin: "12px",
//                         padding: "8px 10px",
//                         fontWeight: "600",
//                         background:
//                           selectedBills.length <= 0
//                             ? "rgba(141, 141, 141, 0.97)"
//                             : "#C1272D",
//                         color: "white",
//                         borderRadius: "8px",
//                         cursor:
//                           selectedBills.length <= 0
//                             ? "not-allowed"
//                             : loading
//                               ? "not-allowed"
//                               : "pointer",
//                       }}
//                     >
//                       <img
//                         src="/Reject-Selected32.png"
//                         style={{
//                           width: "1rem",
//                           height: "1rem",
//                           filter: "brightness(0) invert(1)",
//                         }}
//                       />{" "}
//                       {loading ? "Processing..." : "Reject Selected"}
//                     </button>

//                     {adminData.Role !== "Deputy Engineer" && (
//                       <button
//                         onClick={() => setRejectpanelhide(3)}
//                         disabled={selectedBills.length <= 0 ? true : loading}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "3px",
//                           margin: "12px",
//                           padding: "8px 10px",
//                           fontWeight: "600",
//                           background:
//                             selectedBills.length <= 0
//                               ? "rgba(141, 141, 141, 0.97)"
//                               : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
//                           color: "white",
//                           borderRadius: "8px",
//                           cursor:
//                             selectedBills.length <= 0
//                               ? "not-allowed"
//                               : loading
//                                 ? "not-allowed"
//                                 : "pointer",
//                         }}
//                       >
//                         <img
//                           src="/Send-Back-Selected32.png"
//                           style={{
//                             width: "1rem",
//                             height: "1rem",
//                             filter: "brightness(0) invert(1)",
//                           }}
//                         />{" "}
//                         {loading ? "Processing..." : "Send Back Selected"}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {rejectPanelhide === 2 && (
//           <div className="col-12 RejectPanelContainer">
//             <div className="Rejectpanel">
//               <form action="">
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-3">
//                       <label className="fw-bold">
//                         {t("Remark")} <span className="text-danger">*</span>
//                       </label>
//                     </div>
//                     <div className="col-8">
//                       <textarea
//                         name=""
//                         id=""
//                         placeholder={t("Enter Remark")}
//                         onChange={(e) => setRemark(e.target.value)}
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//               <div className="col-12 ms-auto my-4">
//                 <div className="row">
//                   <div className="col-9 m-auto">
//                     <div
//                       className="col-12"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <button
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           background:
//                             "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                           width: "5rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => approveorrejectSelected("Rejected")}
//                       >
//                         <img src={submit} style={{ width: "15px" }} /> Reject
//                       </button>
//                       <button
//                         type="button"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           backgroundColor: "#f1594c",
//                           width: "6rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => window.location.reload()}
//                       >
//                         {" "}
//                         <img src={Cancel32} style={{ width: "17px" }} />
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {rejectPanelhide === 3 && (
//           <div className="col-12 RejectPanelContainer">
//             <div className="Rejectpanel">
//               <form action="">
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-3">
//                       <label className="fw-bold">
//                         {t("Remark")} <span className="text-danger">*</span>
//                       </label>
//                     </div>
//                     <div className="col-8">
//                       <textarea
//                         name=""
//                         id=""
//                         placeholder={t("Enter Remark")}
//                         onChange={(e) => setRemark(e.target.value)}
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//               <div className="col-12 ms-auto my-4">
//                 <div className="row">
//                   {/* <div className="col-3"></div> */}
//                   <div className="col-9 m-auto">
//                     <div
//                       className="col-12"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <button
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           background:
//                             "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                           width: "8rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => approveorrejectSelected("SendBack")}
//                       >
//                         <img src={submit} style={{ width: "15px" }} /> Send Back
//                       </button>
//                       <button
//                         type="button"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           backgroundColor: "#f1594c",
//                           width: "6rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => window.location.reload()}
//                       >
//                         {" "}
//                         <img src={Cancel32} style={{ width: "17px" }} />
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default ProposalInwardList;
